import React, { useCallback, useState } from 'react';
import { EntityRoutes } from 'routes/constants';
import AutocompleteSelect from 'UI/components/molecules/AutocompleteSelect';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';
import { ContactRole } from 'UI/constants/entityTypes';
import { DataTableLink } from 'UI/utils/renderers';

import { MatchMakingTable } from './components';
import { COPIES } from './MatchMakingTab.constants';

const ContactRoutes = {
  [ContactRole.HiringAuthority]: EntityRoutes.HiringAuthorityProfile,
  [ContactRole.Name]: EntityRoutes.ContactProfile,
  [ContactRole.Candidate]: EntityRoutes.CandidateProfile
};

const EXTRA_RENDERERS = {
  contactLink: value => {
    if (!value) return null;

    const { id, roleId, fullName } = value;
    const route = ContactRoutes[roleId];

    return id && route ? (
      <DataTableLink id={id} text={fullName} route={route} enableInTabRedirect />
    ) : null;
  }
};

export const MatchMakingTab = ({ availableEntityTypesToMatch = [], DataTableProps, profileId }) => {
  const [selectedEntityTypeConfig, setSelectedEntityTypeConfig] = useState(
    availableEntityTypesToMatch.length > 0 ? availableEntityTypesToMatch[0] : null
  );
  const [isInteractionAllowed, setIsInteractionAllowed] = useState(false);

  const {
    columns = [],
    disableTableActions = false,
    endpoint = null,
    formatResponse = null,
    secondaryEnpoint = null,
    tablePreferencesKey = null
  } = selectedEntityTypeConfig || {};
  const entityTypeToMatch = {
    id: selectedEntityTypeConfig?.id,
    singular: selectedEntityTypeConfig?.singular,
    title: selectedEntityTypeConfig?.title,
    type: selectedEntityTypeConfig?.type
  };

  const handleSelectEntityType = (name, value) => {
    setSelectedEntityTypeConfig(value);
  };

  const handleAllowInteraction = useCallback(() => {
    setIsInteractionAllowed(true);
  }, []);

  const handleDisallowInteraction = useCallback(() => {
    setIsInteractionAllowed(false);
  }, []);

  const entityTypeSelector = (
    <AutocompleteSelect
      defaultOptions={availableEntityTypesToMatch}
      disableClearable
      disabled={availableEntityTypesToMatch.length <= 1 || !isInteractionAllowed}
      name="entityType"
      onSelect={handleSelectEntityType}
      placeholder={COPIES.labels.inventoryToMatch}
      selectedValue={selectedEntityTypeConfig}
    />
  );

  return availableEntityTypesToMatch.length > 0 ? (
    <MatchMakingTable
      columns={columns}
      dataTableProps={DataTableProps}
      disableTableActions={disableTableActions}
      endpoint={endpoint}
      entityTypeSelector={entityTypeSelector}
      entityTypeToMatch={entityTypeToMatch}
      extraRenderers={EXTRA_RENDERERS}
      formatResponse={formatResponse}
      isInteractionAllowed={isInteractionAllowed}
      key={entityTypeToMatch?.id}
      onFetchingCompleted={handleAllowInteraction}
      onFetchingStarted={handleDisallowInteraction}
      onProcessCompleted={handleAllowInteraction}
      onProcessStarted={handleDisallowInteraction}
      profileId={profileId}
      secondaryEnpoint={secondaryEnpoint}
      tablePreferencesKey={tablePreferencesKey}
    />
  ) : (
    <EmptyPlaceholder title={COPIES.emptyState.noMatchMakingConfigured} />
  );
};
